import React from 'react'
import { graphql } from 'gatsby'
import { IGatsbyImageData } from 'gatsby-plugin-image'

import StaggeredImageCards, {
  StaggeredImageCard,
  StaggeredImageCardsContent,
} from 'src/components/organisms/slidersAndGrids/staggeredImageCards'

type StaggeredImageCardsItem = {
  subtitle?: string | null
  title?: string | null
  image?: {
    gatsbyImageData?: IGatsbyImageData | null
    alt?: string | null
  } | null
}

type PrismicPageDataBodyStaggeredImageCards = {
  primary: {
    anchor?: string | null
    show_decorations?: boolean | null
  }
  items: StaggeredImageCardsItem[]
}

type Props = {
  slice: PrismicPageDataBodyStaggeredImageCards
}

const StaggeredImageCardsSlice = ({ slice }: Props) => {
  const items: StaggeredImageCard[] = (slice.items ?? []).map(item => ({
    subtitle: item.subtitle ?? undefined,
    title: item.title ?? undefined,
    image: item.image?.gatsbyImageData ?? undefined,
    imageAlt: item.image?.alt ?? undefined,
  }))

  const content: StaggeredImageCardsContent = {
    anchor: slice.primary.anchor ?? undefined,
    showDecorations: slice.primary.show_decorations ?? undefined,
    items,
  }

  return <StaggeredImageCards content={content} />
}

export default StaggeredImageCardsSlice

export const StaggeredImageCardsFragment = graphql`
  fragment PageDataBodyStaggeredImageCards on PrismicPageDataBodyStaggeredImageCards {
    primary {
      anchor
      show_decorations
    }
    items {
      subtitle
      title
      image {
        gatsbyImageData
        alt
      }
    }
  }
`
